import axios from 'axios'
import {TSaleSummaryReportsResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const REPORTS_URL = `${API_URL}/kpi/reports`

const getSaleSummaryReportById = (
  filter: string,
  filterFranchise: string
): Promise<TSaleSummaryReportsResponse> => {
  const params = new URLSearchParams()

  if (filter.length > 0) {
    params.append('filter_by_month_year', filter)
  }

  if (filterFranchise.length) {
    params.append('franchises', filterFranchise)
  }

  return axios
    .get(`${REPORTS_URL}/summary-growth-month${params.toString() ? `?${params}` : ''}`)
    .then((response: any) => response.data)
}

export {getSaleSummaryReportById}
